import { Table, Text, TextProps } from "@mantine/core";


interface TableEmptyRowProps {
  colSpan: number;
  message: string;
  textProps?: TextProps;
}

export const TableEmptyRow = ({
  colSpan,
  message,
  textProps = {},
}: TableEmptyRowProps) => {
  return (
    <Table.Tr h={200}>
      <Table.Td colSpan={colSpan}>
        <Text fz={15} c="dimmed" lh={1.5} ta="center" {...textProps}>
          {message}
        </Text>
      </Table.Td>
    </Table.Tr>
  );
};
